
import './buttonModal.scss';

import React, { FunctionComponent } from 'react';
import { PromiseVoidCallback, VoidCallback } from '../../../types/helpers';

type modalButton = {
    label: string,
    onClick: VoidCallback | PromiseVoidCallback,
    disabled: boolean
}

export const ModalButton: FunctionComponent<modalButton> = (props) => {
    return(
        <div className="modal-button" onClick={props.onClick}>
            <button className="button">{props.label}</button>
        </div>
    )
}